import React from 'react';
import { IUpdateAvailablePageProps } from './types';
import { Button } from 'react-bootstrap';
import styles from './UpdateAvailable.module.css';

const UpdateAvailablePage: React.FC<IUpdateAvailablePageProps> = ({
  onUpdate,
}) => (
  <div className={styles.container}>
    <div className={styles.status}>VisIT</div>
    <p className={styles.heading}>UPDATE AVAILABLE</p>
    <div className="my-4">
      <img src="logo192.png" alt="logo" />
    </div>
    <p>
      An update of the software is available, please click the button below get
      the latest version
    </p>
    <Button variant="primary" onClick={onUpdate}>
      Update
    </Button>
  </div>
);

export default UpdateAvailablePage;
